import { Component, Input, OnInit, HostListener, AfterViewInit } from '@angular/core';
import { RowDragEndEvent } from 'ag-grid-community';
import { commonFunctions } from '../../../common/classes/common.class';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { getTimeDateRange } from 'app/core/store/timeDateRangeSelection/timeDateRangeSelection.selectors';
import { getExpenseDateRange } from 'app/core/store/expenseDateRangeSelection/expenseDateRangeSelection.selectors';
import { Constants } from '../../../common/utilities/constants.config';
import { EntryDialogComponent } from '../entry-dialog/entry-dialog.component';
import { GridApi, GridOptions } from 'ag-grid-community';
import { getCurrentUser } from 'app/core/store/currentUser/user.selectors';
import { ConsultantModel } from '../../../common/models/consultant.model';
import { DateRangeModel } from '../../../common/models/date-range.model';
import { EntryGridConfigService } from '../../../common/services/entry-grid-config.service';
import { DateUtility } from '../../../common/utilities/date.utility';
import { URLPaths } from '../../../common/utilities/urlPaths.config';
import { UserService } from '../../../common/services/user.service';
import { TimeEntryService } from '../../../common/services/time-entry.service';
import { setTimeEntryGridConfig } from 'app/core/store/timeEntryGridConfig/timeEntryGridConfig.actions';
import { TimeEntryGridConfigModel } from '../../../common/models/time-entry-grid-config.model';
import { SnackbarService } from '../../../common/services/snackbar.service';
import { TimeEntryModel } from '../../../common/models/TimeEntry.model';
import { ProjectsService } from '../../../common/services/projects.service';
import { ProjectModel } from '../../../common/models/project.model';
import { ProjectTaskModel } from '../../../common/models/project-task.model';
import { ProjectTaskService } from '../../../common/services/project-task.service';
import { ConsultantProjectRateParameterModel } from '../../../common/models/consultant-rate.model';
import { ConsultantRateModel } from '../../../common/models/consultant-rate.model';
import { ConsultantRateService } from '../../../common/services/consultant-rate.service';
import { getTimeEntryGridConfig } from 'app/core/store/timeEntryGridConfig/timeEntryGridConfig.selector';
import { EntryTableService } from '../../../common/services/entry-table.service';
import { ExpenseEntryService } from '../../../common/services/expense-entry.service';
import { setExpenseEntryGridConfig } from 'app/core/store/expenseEntryGridConfig/expenseEntryGridConfig.actions';
import { ExpenseEntryGridConfigModel } from '../../../common/models/expense-entry-grid-config.model';
import { getExpenseEntryGridConfig } from 'app/core/store/expenseEntryGridConfig/expenseEntryGridConfig.selector';
import { ExpenseEntryModel } from '../../../common/models/ExpenseEntry.model';
import { LogoutService } from '../../../common/services/logout.service';

@Component({
    selector: 'app-entry-table',
    templateUrl: './entry-table.component.html',
    styleUrls: ['./entry-table.component.scss'],
})
export class EntryTableComponent implements OnInit, AfterViewInit {
    @Input() entryPageType: string;
    weekStart: string;
    weekEnd: string;
    getDateRange: any;
    setEntryGridConfiguration: any;
    entryCountHashMap: any;
    dateEntryCountHashMap: any;
    public agGridAPI: GridApi;
    agGridColumnAPI: any;
    gridOptions: GridOptions = {};
    currentUser: ConsultantModel;
    week: DateRangeModel[];
    consultant = '';
    currentWeekDates: any;
    subscription: Subscription;
    entryGridConfig: any;
    rowDragModeIsCopy = true;
    rowSelection: string;
    consultantRateEntryDate: string;
    defaultColDef: any;
    selectedProject: ProjectModel;
    selectedProjectTask: ProjectTaskModel;
    entryService: any;
    entryGridConfigURLPath: string;
    getEntryGridConfiguration: any;
    domLayout: any = 'autoHeight';
    entryModel: any;
    beginLogoutAction: boolean = false;
    isUnsavedChangesPresent: boolean = false;
    rowForUpdate: any = null;
    inlineEditCols = [];
    nodeStatus = [];
    agGridCopy: any;

    /**
     * Constructor
     */
    constructor(
        public datePipe: DatePipe,
        private _store: Store,
        private _dialog: MatDialog,
        private _userService: UserService,
        private _timeEntryService: TimeEntryService,
        private _snackBarService: SnackbarService,
        private _projectsService: ProjectsService,
        private _projectTaskService: ProjectTaskService,
        private _consultantRateService: ConsultantRateService,
        private _entryTableService: EntryTableService,
        private _entryGridConfigService: EntryGridConfigService,
        private _expenseEntryService: ExpenseEntryService,
        private _logoutService: LogoutService
    ) {
        this.defaultColDef = {
            width: 100,
            filter: true,
            resizable: true,
            headerCheckboxSelection: (params) => {
                const diaplayedColumns = params.columnApi.getAllDisplayedColumns();
                return diaplayedColumns[0] === params.column;
            },
        };
        this.gridOptions.groupDefaultExpanded = 1;
        this.gridOptions.groupSelectsChildren = true;
        this.gridOptions.getRowStyle = (param) => {
            if (param.node.group) {
                return {
                    background: '#6ac738',
                    'font-weight': 'bold'

                };
            } else {
                if (param.data.status !== 'clean' && param.data.status !== 'dummy') {
                    if (
                        param.data.status === 'bad' ||
                        param.data.status === 'multiplerate'
                    ) {
                        return { background: '#ffc7ce' };
                    } else {
                        return { background: '#ffc107' };
                    }
                }
            }
        };
        this.gridOptions.suppressAggFuncInHeader = true;
        this.rowSelection = 'multiple';
    }
    ngAfterViewInit(): void {
        this._store.select(this.getDateRange).subscribe((data) => {
            if (data) {
                this.weekStart = data['startDate'];
                this.weekEnd = data['endDate'];
                if ((this.agGridCopy && !this.agGridCopy.destroyCalled) && !this.beginLogoutAction) {
                    this._entryTableService.getEntryTableEntries(
                        this.agGridAPI,
                        this.entryPageType
                    );
                }
            }
        });

        this._store.select(getCurrentUser).subscribe((data) => {
            this.currentUser = data;
            if ((this.agGridCopy && !this.agGridCopy.destroyCalled) && !this.beginLogoutAction) {
                this._entryTableService.getEntryTableEntries(
                    this.agGridAPI,
                    this.entryPageType
                );
            }
        })

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit() {
        switch (this.entryPageType) {
            case Constants.NAV_TIME_ENTRY_ACTUALS:
                this.getDateRange = getTimeDateRange;
                this.entryService = this._timeEntryService;
                this.entryGridConfigURLPath = URLPaths.URL_TIME_ENTRY_GRID_CONFIG;
                this.setEntryGridConfiguration = setTimeEntryGridConfig;
                this.getEntryGridConfiguration = getTimeEntryGridConfig;
                this.entryModel = TimeEntryModel;
                this.inlineEditCols = ['ag-Grid-AutoColumn', 'Hours'];
                this.nodeStatus = ['dummy', 'bad', 'multiplerate'];
                break;
            case Constants.NAV_EXPENSE_ENTRY:
                this.getDateRange = getExpenseDateRange;
                this.entryService = this._expenseEntryService;
                this.entryGridConfigURLPath = URLPaths.URL_EXPENSE_ENTRY_GRID_CONFIG;
                this.setEntryGridConfiguration = setExpenseEntryGridConfig;
                this.getEntryGridConfiguration = getExpenseEntryGridConfig;
                this.entryModel = ExpenseEntryModel;
                this.inlineEditCols = [
                    'ag-Grid-AutoColumn',
                    'AmountSpent',
                    'Currency_From',
                ];
                this.nodeStatus = ['dummy'];
                break;
            case Constants.NAV_SUSTAINABILITY:
                this.getDateRange = getTimeDateRange;
                this.entryService = this._timeEntryService;
                this.entryGridConfigURLPath = URLPaths.URL_TIME_ENTRY_GRID_CONFIG;
                this.setEntryGridConfiguration = setTimeEntryGridConfig;
                this.getEntryGridConfiguration = getTimeEntryGridConfig;
                this.entryModel = TimeEntryModel;
                this.inlineEditCols = ['ag-Grid-AutoColumn', 'Hours'];
                this.nodeStatus = ['dummy', 'bad', 'multiplerate'];
                break;
        }
        this._logoutService.beginLogoutAction.subscribe((data) => {
            this.beginLogoutAction = data;
        });
        // this._store.select(this.getDateRange).subscribe((data) => {
        //     if (data) {
        //         this.weekStart = data['startDate'];
        //         this.weekEnd = data['endDate'];
        //         if (this.agGridAPI !== undefined && !this.beginLogoutAction) {
        //             this._entryTableService.getEntryTableEntries(
        //                 this.agGridAPI,
        //                 this.entryPageType
        //             );
        //         }
        //     }
        // });
        this.entryService.entryIsUnsavedChangesPresent.subscribe((data) => {
            this.isUnsavedChangesPresent = data;
        });

        this.entryService.rowDragMode.subscribe((data) => {
            this.rowDragModeIsCopy = data;
        });
        this.entryService.entryCountHashMap.subscribe((data) => {
            this.dateEntryCountHashMap = data;
        });
        this._store.select(getCurrentUser).subscribe((data) => {
            this.currentUser = data;
            // this.onGridReady()
        })
        this._store.select(this.getEntryGridConfiguration).subscribe((data) => {
            this.entryGridConfig = data;
        });
        this.gridOptions.columnDefs = this.entryService.columnDefs;
        this.gridOptions.autoGroupColumnDef = this.entryService.autoGroupColumnDefs;
        this.gridOptions.stopEditingWhenCellsLoseFocus = true;
        this.entryService.setEntryTDate(DateUtility.formatStringfromDate(DateUtility.createDateType()));
    }

    @HostListener('window:beforeunload', ['$event'])
    beforeUnloadHander($event) {
        if (this.isUnsavedChangesPresent) {
            return ($event.returnValue =
                Constants.MSG_CONFIRM_DISCARD_CHANGES);
        }
        return true;
    }

    @HostListener('window:pagehide', ['$event'])
    pageHidedHanderforIos($event) {
        if (this.isUnsavedChangesPresent) {
            return ($event.returnValue =
                Constants.MSG_CONFIRM_DISCARD_CHANGES);
        }
        return true;
    }

    //   AG Grid Config
    setEntryGridConfig(entryGridConfig) {
        this._store.dispatch(this.setEntryGridConfiguration({ entryGridConfig }));
    }

    //Set Date Entry Count Hashmap to store
    setDateEntryCountHashMap(dateEntryCountHashMap) {
        this.entryService.entryCountHashMap.next(dateEntryCountHashMap);
    }

    //Set boolean whether if any unsaved changes are present
    setEntryIsUnsavedChangesPresent(isUnsavedChangesPresent) {
        this.entryService.entryIsUnsavedChangesPresent.next(
            isUnsavedChangesPresent
        );
    }

    //   Get the consultant's rate for Project
    getConsultantProjectRate(values): void {
        const consultantClientProjectRate =
            new ConsultantProjectRateParameterModel();
        let selectedConsultantRate = new ConsultantRateModel();
        let entryDate: any;
        if (
            !commonFunctions.isNullOrUndefined(this.consultantRateEntryDate) &&
            this.consultantRateEntryDate !== ''
        ) {
            entryDate = DateUtility.createDateTypefromDate(
                this.consultantRateEntryDate
            );
            consultantClientProjectRate.entrydate =
                String(entryDate.getFullYear()) +
                String(
                    (Number(entryDate.getMonth()) + 1 < 10 ? '0' : '') +
                    (Number(entryDate.getMonth()) + 1)
                );
        } else {
            consultantClientProjectRate.entrydate = '';
        }
        consultantClientProjectRate.employee = values.Employee;
        consultantClientProjectRate.client = values.Client;
        consultantClientProjectRate.project = values.Project;
        this._consultantRateService
            .getConsultantByProject(consultantClientProjectRate)
            .subscribe((consultantRate) => {
                this._snackBarService.dismissSnackBar();
                if (
                    !commonFunctions.isNullOrUndefined(consultantRate) &&
                    consultantRate.length > 0
                ) {
                    if (values.Rate === -1) {
                        if (consultantRate.length === 1) {
                            selectedConsultantRate = consultantRate.filter((rate) => {
                                return (
                                    rate.Client.toLowerCase() === values.Client.toLowerCase() &&
                                    rate.Project.toLowerCase() === values.Project.toLowerCase()
                                );
                            })[0];
                        } else {
                            selectedConsultantRate.Rate = '0';
                            selectedConsultantRate.Converted_Currency_Code = '';
                            selectedConsultantRate.Converted_Currency_Symbol = '';
                            if (values.status !== 'bad') {
                                values.status = 'multiplerate';
                            }
                        }
                        if (commonFunctions.isNullOrUndefined(selectedConsultantRate)) {
                            selectedConsultantRate = consultantRate.filter(
                                (rates) => rates.Is_Default_Rate === 1
                            )[0];
                        }
                        if (!commonFunctions.isNullOrUndefined(selectedConsultantRate)) {
                            values.Rate = selectedConsultantRate.Converted_Rate;
                            values.Currency_Code =
                                selectedConsultantRate.Converted_Currency_Code;
                            values.Currency_symbol_short =
                                selectedConsultantRate.Converted_Currency_Symbol;
                        }
                    } else {
                        let minrateDifference = -1;
                        let rateDifference = 0;
                        for (const rate of consultantRate) {
                            rateDifference =
                                parseFloat(values.Rate) - parseFloat(rate.Converted_Rate);
                            rateDifference =
                                rateDifference < 0 ? -rateDifference : rateDifference;
                            if (
                                rateDifference < minrateDifference ||
                                minrateDifference === -1
                            ) {
                                minrateDifference = rateDifference;
                                selectedConsultantRate = rate;
                            }
                        }
                        values.Rate = selectedConsultantRate.Converted_Rate;
                        values.Currency_Code =
                            selectedConsultantRate.Converted_Currency_Code;
                        values.Currency_symbol_short =
                            selectedConsultantRate.Converted_Currency_Symbol;
                    }
                } else {
                    values.Rate = 0;
                }
                if (
                    !commonFunctions.isNullOrUndefined(values) &&
                    !commonFunctions.isNullOrUndefined(values.TDate)
                ) {
                    this.entryService.addRecordsToGrid(this.agGridAPI, values);
                    if (values.status === 'bad') {
                        this._snackBarService.showSnackBar(
                            Constants.SNACKBAR_MSG_ENTRY_BAD_ENTRIES,
                            null,
                            'warning'
                        );
                    } else {
                        if (values.status === 'multiplerate') {
                            this._snackBarService.showSnackBar(
                                Constants.SNACKBAR_MSG_ENTRY_MULTIPLE_RATES,
                                'close',
                                'warning'
                            );
                        }
                    }
                }
                this.entryService.updateActualsAndChangedEntries(this.agGridAPI);
            });
    }

    //   Get the project task
    getProjectTask(values): void {
        this._projectTaskService
            .getProjectTasks(values.Client, values.Project)
            .subscribe((projectTasks) => {
                this.selectedProjectTask = projectTasks.filter((task) => {
                    return (
                        task.Task_name.toLowerCase() === values.Task_Code.toLowerCase()
                    );
                })[0];
                if (!commonFunctions.isNullOrUndefined(this.selectedProjectTask)) {
                    values.Task_Code = this.selectedProjectTask.Task_name;
                    values.Task_Name = this.selectedProjectTask.Task_description;
                    values.Task_id = this.selectedProjectTask.Task_id;
                } else {
                    values.status = 'bad';
                }
                this.getConsultantProjectRate(values);
            });
    }
    fetchBusinessExpenseEntries(rowData) {
        this.entryService.getBusinessExpenses(
            rowData.TDate, // startDate
            rowData.TDate, // endDate
            rowData.Employee,
            rowData.Client + '-' + rowData.Project
        ).subscribe((data) => {
            if (data && data.length > 0) {
                data.forEach((record) => {
                    // Optionally mark them as 'fetched from ADLS' if needed
                    record.status = 'adls';
                    this.entryService.addRecordsToGrid(this.agGridAPI, record);
                });
            }
        });
    }

    // Get the Projects for the consultant
    getProjects(values): void {
        this._projectsService
            .getProjects(
                false,
                this.currentUser['Employee'],
                this.weekStart,
                this.weekEnd
            )
            .subscribe((projectList) => {
                if (
                    !commonFunctions.isNullOrUndefined(values.Project) &&
                    !commonFunctions.isNullOrUndefined(values.Client)
                ) {
                    this.selectedProject = projectList.filter((projects) => {
                        return (
                            projects.Project.toLowerCase() === values.Project.toLowerCase() &&
                            projects.Client.toLowerCase() === values.Client.toLowerCase()
                        );
                    })[0];
                    if (!commonFunctions.isNullOrUndefined(this.selectedProject)) {
                        values.Client = this.selectedProject.Client;
                        values.Project = this.selectedProject.Project;
                        values.ClientName = this.selectedProject.ClientName;
                        values.ProjectName = this.selectedProject.Description;
                        if (
                            commonFunctions.isNullOrUndefined(values.Charge) ||
                            values.Charge === '' ||
                            this.selectedProject.Charge.toLowerCase() === 'no'
                        ) {
                            values.Charge = this.selectedProject.Charge;
                        }
                        this.getProjectTask(values);
                    } else {
                        values.status = 'bad';
                        this.getConsultantProjectRate(values);
                    }
                }
            });
    }
    assignValues(params): void {
        this._snackBarService.showSnackBar(
            Constants.SNACKBAR_MSG_WAITING_FOR_API_RESPONSE,
            null,
            'info'
        );

        // Remove header row if present
        if (
            params[0][0] === 'EntryDate' &&
            params[0][1] === 'Client' &&
            params[0][2] === 'Project' &&
            params[0][3] === 'TaskName' &&
            params[0][4] === 'TaskDescription' &&
            params[0][5] === 'Hours'
        ) {
            params.shift();
        }

        let count = params.length - 1;
        if (params[count].length === 1 && params[count][0] === '') {
            params.pop();
        }

        for (const values of params) {
            const selectedCopyClipboard = new this.entryModel();
            selectedCopyClipboard.Rate = -1;
            selectedCopyClipboard.TDate = '';

            if (values.length > 5) {
                // Blank row check
                if (
                    values[0] === '' &&
                    values[1] === '' &&
                    values[2] === '' &&
                    values[3] === '' &&
                    values[4] === '' &&
                    values[5] === ''
                ) {
                    this._snackBarService.showSnackBar(
                        Constants.SNACKBAR_MSG_ENTRY_BLANK_ROW,
                        '',
                        'warning'
                    );
                    continue;
                }

                // Process date
                if (values[0] !== '' && !commonFunctions.isNullOrUndefined(values[0])) {
                    this.consultantRateEntryDate = values[0];
                    selectedCopyClipboard.TDate = DateUtility.formatStringfromDate(
                        DateUtility.createDateTypefromDate(values[0])
                    );

                    if (this.entryPageType == Constants.NAV_TIME_ENTRY_ACTUALS) {
                        selectedCopyClipboard.Invoice_Date = selectedCopyClipboard.TDate;
                    } else if (this.entryPageType == Constants.NAV_EXPENSE_ENTRY) {
                        selectedCopyClipboard.Invoice_date = selectedCopyClipboard.TDate;
                    }
                } else {
                    this.consultantRateEntryDate = '';
                }

                // Common fields
                selectedCopyClipboard.Client = values[1] ?? '';
                selectedCopyClipboard.Project = values[2] ?? '';
                selectedCopyClipboard.Task_Code = values[3] ?? '';
                selectedCopyClipboard.Task_Description = values[4] ?? '';
                selectedCopyClipboard.Hours =
                    values[5] && parseFloat(values[5]) > 0 && parseFloat(values[5]) < 25
                        ? values[5]
                        : 0;

                if (
                    !commonFunctions.isNullOrUndefined(values[6]) &&
                    values[6] !== ''
                ) {
                    selectedCopyClipboard.Rate = values[6];
                }

                if (
                    !commonFunctions.isNullOrUndefined(values[7]) &&
                    values[7] !== ''
                ) {
                    if (this.entryPageType == Constants.NAV_TIME_ENTRY_ACTUALS) {
                        selectedCopyClipboard.Invoice_Date =
                            DateUtility.formatStringfromDate(
                                DateUtility.createDateTypefromDate(values[7])
                            );
                    } else if (this.entryPageType == Constants.NAV_EXPENSE_ENTRY) {
                        selectedCopyClipboard.Invoice_date =
                            DateUtility.formatStringfromDate(
                                DateUtility.createDateTypefromDate(values[7])
                            );
                    }
                }

                if (
                    !commonFunctions.isNullOrUndefined(values[8]) &&
                    values[8] !== ''
                ) {
                    selectedCopyClipboard.Charge = values[8];
                }

                // ====== MODE-SPECIFIC FIELDS ======
                if (!commonFunctions.isNullOrUndefined(values.Mode)) {
                    if (values.Mode === 'Plane') {
                        selectedCopyClipboard.FromAirport = values.FromAirport ?? '';
                        selectedCopyClipboard.ToAirport = values.ToAirport ?? '';
                    } else if (values.Mode === 'Taxi' || values.Mode === 'Train') {
                        selectedCopyClipboard.Distance = values.Distance ?? 0;
                        selectedCopyClipboard.DistanceUnit = values.DistanceUnit ?? 'KM';
                    }
                }

                // Employee & week
                selectedCopyClipboard.Employee = this.currentUser['Employee'];
                selectedCopyClipboard['startDate'] = this.weekStart;
                selectedCopyClipboard['endDate'] = this.weekEnd;

                // Call existing function to fetch project/task info
                this.getProjects(selectedCopyClipboard);
            } else {
                if (values.length === 0) {
                    this._snackBarService.showSnackBar(
                        Constants.SNACKBAR_MSG_ENTRY_BLANK_ROW,
                        '',
                        'warning'
                    );
                } else {
                    this._snackBarService.showSnackBar(
                        Constants.SNACKBAR_MSG_ENTRY_MISSING_COLUMNS,
                        '',
                        'warning'
                    );
                }
            }
        }
    }


    // Auto Size required columns : Apart from checkbox
    autoSizeAllColumns(): void {
        const allColumnIds = [];
        this.agGridColumnAPI.getAllColumns().forEach((column) => {
            if (column.colId !== 'checkbox') {
                allColumnIds.push(column.colId);
            }
        });
        this.agGridColumnAPI.autoSizeColumns(allColumnIds);
        this.entryService.setGridColumnApi(this.agGridColumnAPI);
    }

    // Remove the dummy row when there is a entry in a date
    removeDummyChildrenFromParent(params, result) {
        const dummyLeafChild = params.node.parent.parent.allLeafChildren.filter(
            (leafChild) => {
                return (
                    leafChild.data.status === 'dummy' &&
                    leafChild.data.TDate === result['TDate']
                );
            }
        )[0];
        if (!commonFunctions.isNullOrUndefined(dummyLeafChild)) {
            this.agGridAPI.applyTransaction({ remove: [dummyLeafChild.data] });
        }
    }

    onCellDoubleClicked(params: any): void {
        // Store the clicked row for update
        this.rowForUpdate = params.data;

        if (
            params.node.group ||
            commonFunctions.isNullOrUndefined(params.data) ||
            !(commonFunctions.isNullOrUndefined(params.data.Invoice_id) || params.data.Invoice_id === 0) ||
            (params.data.Client === 'AD' && (params.data.Project === 'TS' || params.data.Project === 'EX'))
        ) {
            return;
        }

        if (this.inlineEditCols.includes(params.column.colId) && !this.nodeStatus.includes(params.node.data.status)) {
            return;
        }

        // Set current entry date in service
        this.entryService.setEntryTDate(params.data.TDate);

        // Configure dialog
        const dialogConfig = new MatDialogConfig();
        dialogConfig.maxWidth = 'clamp(340px, 92vw, 900px)';
        dialogConfig.width = '100%';
        dialogConfig.height = 'auto';
        dialogConfig.disableClose = true;

        // Clone row to avoid mutating grid row before dialog save
        dialogConfig.data = { ...params.data };
        dialogConfig.data.__createdFromDragCopy = params.data.__createdFromDragCopy === true;
        dialogConfig.data.startDate = this.weekStart;
        dialogConfig.data.endDate = this.weekEnd;
        dialogConfig.data.entryPageType = this.entryPageType;

        // Decide create vs edit (grid status-based)
        const isCreateRow = params.data.status === 'create' || params.data.status === 'dummy';
        dialogConfig.data.Mode = isCreateRow ? 'create' : 'edit';

        // Default month/year/loginName from row date
        const month = new Date(params.data.TDate).getMonth() + 1;
        const year = new Date(params.data.TDate).getFullYear();

        // Dynamically resolve the login name from the grid schema instead of the Ngrx global store which tracks the impersonator
        const resolveLoginName = (e: any) => this.currentUser?.LoginName || e.Entry_Owner_LoginName || e.Login_Name || e.LoginName || e.loginName;
        const loginName = resolveLoginName(params.data);

        // Transport mode ID filters for dialog dropdown
        const modeMapping: Record<string, number[]> = {
            Mileage: [1, 3, 10, 11],
            'Motor Vehicle Hire': [1, 3, 10, 11],
            'Taxi Travel': [12],
            'Taxi travel': [12],
            'Train Travel': [2, 7],
            'Train/Bus Travel': [2, 7, 8],
            'Plane Travel': [15],
        };

        dialogConfig.data.allowedTransportModeIds = modeMapping[params.data.Description] || [];
        // --- Roundtrip normalization helper (ADLS 0/1 -> UI boolean) ---
        const applyRoundTrip = (target: any, isRoundtripVal: any) => {
            const rtNum = Number(isRoundtripVal ?? 0);
            target.is_roundtrip = rtNum;
            target.RoundTrip = rtNum === 1;
        };


        //  helper: ALWAYS open dialog through one place (prevents “create mode doesn’t open” bug)
        const openDialog = () => {
            const dialogRef = this._dialog.open(EntryDialogComponent, dialogConfig);
            dialogRef.afterClosed().subscribe((result) => {
                if (result && typeof result !== 'boolean') {
                    this.setEntryIsUnsavedChangesPresent(true);

                    // CLONE PATH (Copy === true)
                    if (result.Copy === true) {
                        const newRow: any = structuredClone(result);

                        // Always treat clone as new row
                        newRow.status = 'create';
                        newRow.Invoice_id = 0;
                        newRow.travel_id = 0;
                        newRow.carbon_emission = null;

                        // Reset primary keys safely
                        if (this.entryPageType === Constants.NAV_TIME_ENTRY_ACTUALS) {
                            newRow.Time_ID = 0;
                            newRow.Invoice_Date = newRow.TDate;
                        } else if (this.entryPageType === Constants.NAV_EXPENSE_ENTRY) {
                            newRow.ExpenseID = 0;
                            newRow.Invoice_date = newRow.TDate;
                        }

                        // Add cloned row WITHOUT modifying original row
                        this.agGridAPI.applyTransaction({ add: [newRow] });
                    }

                    // NORMAL EDIT PATH (Copy !== true)
                    else {
                        Object.assign(params.data, result);

                        // For saved rows -> update, for unsaved -> create
                        params.data.status =
                            (params.data.Time_ID && params.data.Time_ID !== 0) ||
                                (params.data.ExpenseID && params.data.ExpenseID !== 0)
                                ? 'update'
                                : 'create';

                        params.data.__hasDialogEdits = true;

                        this.agGridAPI.applyTransaction({ update: [params.data] });
                    }
                }

                // Post-dialog housekeeping (unchanged)
                this.entryService.setEntryTDate(
                    DateUtility.formatStringfromDate(DateUtility.createDateType())
                );
                this.entryService.updateActualsAndChangedEntries(this.agGridAPI);
                this._entryTableService.addEmptyRowsforMissingTDates(this.agGridAPI);
                this.agGridAPI.setColumnDefs(this.gridOptions.columnDefs);
            });
            dialogConfig.data.showClone = true;
        };

        //  EDIT OR DRAGGED: preload ADLS values first, then open dialog
        const isTransportTypeChangedToPlane =
            params.data.Description === 'Plane Travel' &&
            params.data.__sourceExpenseId &&
            params.data.__sourceDescription !== 'Plane Travel' &&
            (!params.data.ExpenseID || params.data.ExpenseID === 0);

        if (isTransportTypeChangedToPlane) {
            dialogConfig.data.travel_id = 0;
            dialogConfig.data.login_name = loginName;
            dialogConfig.data.month = month;
            dialogConfig.data.year = year;

            dialogConfig.data.FromAirport = params.data.FromAirport ?? '';
            dialogConfig.data.ToAirport = params.data.ToAirport ?? '';
            dialogConfig.data.LayoverAirport1 = params.data.LayoverAirport1 ?? '';
            dialogConfig.data.LayoverAirport2 = params.data.LayoverAirport2 ?? '';
            dialogConfig.data.LayoverCount = params.data.LayoverCount ?? 0;

            const fallbackRt =
                params.data?.is_roundtrip ??
                (params.data?.RoundTrip === true ? 1 : 0);

            applyRoundTrip(dialogConfig.data, fallbackRt);

            openDialog();
            return;
        }

        if ((dialogConfig.data.Mode === 'edit' || dialogConfig.data.__createdFromDragCopy === true) && !isTransportTypeChangedToPlane) {

            // Helper: handle dummy row count + drag-copy cleanup, then open dialog
            const prepareAndOpenDialog = () => {
                // Dummy row count logic (only when turning dummy into real entry)
                const dateKey = params.data.TDate.substr(0, 10);
                if (params.data.status === 'dummy') {
                    if (this.dateEntryCountHashMap.get(dateKey) !== -1) {
                        this.dateEntryCountHashMap.set(dateKey, this.dateEntryCountHashMap.get(dateKey) - 1);
                    } else {
                        this.dateEntryCountHashMap.set(dateKey, 0);
                    }
                    this.setDateEntryCountHashMap(this.dateEntryCountHashMap);
                }

                // carbon_emission is computed on backend create; keep null so backend recalculates cleanly
                if (dialogConfig.data.__createdFromDragCopy) {
                    dialogConfig.data.carbon_emission = null;
                }

                openDialog();
            };

            // Time Entry page: no sustainability/ADLS data, open dialog directly
            if (this.entryPageType === Constants.NAV_TIME_ENTRY_ACTUALS) {
                prepareAndOpenDialog();
            } else {
                // Expense Entry page: fetch ADLS sustainability data first, then open dialog
                const fetchMonth = dialogConfig.data.__createdFromDragCopy && params.data.__sourceDate ? new Date(params.data.__sourceDate).getMonth() + 1 : month;
                const fetchYear = dialogConfig.data.__createdFromDragCopy && params.data.__sourceDate ? new Date(params.data.__sourceDate).getFullYear() : year;
                this.entryService.getBusinessExpenses(fetchMonth, fetchYear, loginName).subscribe((adlsData) => {
                    if (adlsData && adlsData.length > 0) {
                        const modeDescMapping: Record<string, string[]> = {
                            Mileage: ['Gas/Petrol Car', 'Diesel Car', 'Hybrid Car', 'Electric Car'],
                            'Motor Vehicle Hire': ['Gas/Petrol Car', 'Diesel Car', 'Hybrid Car', 'Electric Car'],
                            'Taxi Travel': ['Taxi'],
                            'Taxi travel': ['Taxi'],
                            'Train Travel': ['Train', 'Metro/Tube/Subway/Underground'],
                            'Train/Bus Travel': ['Train', 'Metro/Tube/Subway/Underground', 'Bus'],
                            'Plane Travel': ['Plane'],
                        };

                        const rowDesc = (params.data.Description ?? '').trim();
                        const targetExpenseID = dialogConfig.data.__createdFromDragCopy ? params.data.__sourceExpenseId : (params.data.ExpenseID ?? params.data.expense_id);

                        const transportEntry = adlsData.find(entry =>
                            entry.expense_id &&
                            Number(entry.expense_id) === Number(targetExpenseID)
                        );


                        if (transportEntry) {
                            // Attach ADLS identity + partition data
                            dialogConfig.data.travel_id = dialogConfig.data.__createdFromDragCopy ? 0 : (transportEntry.travel_id ?? null);
                            dialogConfig.data.login_name = transportEntry.login_name ?? loginName;
                            dialogConfig.data.month = dialogConfig.data.__createdFromDragCopy ? month : (transportEntry.month ?? month);
                            dialogConfig.data.year = dialogConfig.data.__createdFromDragCopy ? year : (transportEntry.year ?? year);

                            // Fill fields for dialog controls
                            if (params.data.Description === 'Plane Travel') {
                                const segments = adlsData.filter(e =>
                                    e.expense_id && Number(e.expense_id) === Number(targetExpenseID)
                                );

                                if (segments.length > 0) {
                                    segments.sort((a, b) => (a.travel_id || 0) - (b.travel_id || 0));
                                    const firstSegment = segments[0];
                                    const lastSegment = segments[segments.length - 1];

                                    // 3. Populate Dialog with Reconstructed Data
                                    // If status is 'update', it means we have unsaved edited changes in the grid row already

                                    const isUnsavedEdit = params.data.status === 'update' || params.data.__hasDialogEdits;

                                    dialogConfig.data.FromAirport = isUnsavedEdit && params.data.FromAirport !== undefined ? params.data.FromAirport : (firstSegment.plane_origin_desc ?? '');
                                    dialogConfig.data.ToAirport = isUnsavedEdit && params.data.ToAirport !== undefined ? params.data.ToAirport : (lastSegment.plane_destination_desc ?? '');

                                    if (isUnsavedEdit && params.data.LayoverCount !== undefined) {
                                        dialogConfig.data.LayoverCount = params.data.LayoverCount;
                                        dialogConfig.data.LayoverAirport1 = params.data.LayoverAirport1 ?? '';
                                        dialogConfig.data.LayoverAirport2 = params.data.LayoverAirport2 ?? '';
                                    } else {
                                        const layoverAirports: string[] = [];
                                        for (let i = 0; i < segments.length - 1; i++) {
                                            if (segments[i].plane_destination_desc) {
                                                layoverAirports.push(segments[i].plane_destination_desc);
                                            }
                                        }
                                        if (layoverAirports.length >= 1) dialogConfig.data.LayoverAirport1 = layoverAirports[0];
                                        if (layoverAirports.length >= 2) dialogConfig.data.LayoverAirport2 = layoverAirports[1];
                                        dialogConfig.data.LayoverCount = layoverAirports.length;
                                    }

                                    dialogConfig.data.travel_id = dialogConfig.data.__createdFromDragCopy ? 0 : firstSegment.travel_id;
                                    dialogConfig.data.login_name = firstSegment.login_name ?? loginName;
                                    dialogConfig.data.month = dialogConfig.data.__createdFromDragCopy ? month : (firstSegment.month ?? month);
                                    dialogConfig.data.year = dialogConfig.data.__createdFromDragCopy ? year : (firstSegment.year ?? year);

                                    const fallbackRt = isUnsavedEdit && params.data.is_roundtrip !== undefined ? params.data.is_roundtrip : firstSegment.is_roundtrip;
                                    applyRoundTrip(dialogConfig.data, fallbackRt);

                                } else {

                                    const isUnsavedEdit = params.data.status === 'update' || params.data.__hasDialogEdits;
                                    dialogConfig.data.FromAirport = isUnsavedEdit && params.data.FromAirport !== undefined ? params.data.FromAirport : (transportEntry.plane_origin_desc ?? '');
                                    dialogConfig.data.ToAirport = isUnsavedEdit && params.data.ToAirport !== undefined ? params.data.ToAirport : (transportEntry.plane_destination_desc ?? '');
                                    const fallbackRt = isUnsavedEdit && params.data.is_roundtrip !== undefined ? params.data.is_roundtrip : transportEntry.is_roundtrip;
                                    applyRoundTrip(dialogConfig.data, fallbackRt);
                                    if (isUnsavedEdit && params.data.LayoverCount !== undefined) {
                                        dialogConfig.data.LayoverCount = params.data.LayoverCount;
                                        dialogConfig.data.LayoverAirport1 = params.data.LayoverAirport1 ?? '';
                                        dialogConfig.data.LayoverAirport2 = params.data.LayoverAirport2 ?? '';
                                    } else {
                                        dialogConfig.data.LayoverCount = 0;
                                    }
                                }
                            } else {

                                const isUnsavedEdit = params.data.status === 'update' || params.data.__hasDialogEdits;

                                // Ensure dragged/unsaved rows properly fallback to ADLS if they don't have strictly defined edits
                                dialogConfig.data.distance = isUnsavedEdit && params.data.distance !== undefined ? params.data.distance : (params.data.distance ?? params.data.Distance ?? transportEntry.distance ?? 0);
                                dialogConfig.data.distance_unit = isUnsavedEdit && params.data.distance_unit !== undefined ? params.data.distance_unit : (params.data.distance_unit ?? params.data.DistanceUnit ?? transportEntry.distance_unit ?? 'KM');
                                dialogConfig.data.transportmode_desc = isUnsavedEdit && params.data.transportmode_desc !== undefined ? params.data.transportmode_desc : (params.data.transportmode_desc ?? transportEntry.transportmode_desc ?? '');
                                dialogConfig.data.transport_mode_id = isUnsavedEdit && params.data.TransportType !== undefined ? params.data.TransportType : (params.data.TransportType ?? transportEntry.transport_mode_id ?? null);
                                dialogConfig.data.TransportType = dialogConfig.data.transport_mode_id;
                            }
                        } else {
                            console.log('No matching ADLS record found, initializing as new entry');

                            dialogConfig.data.travel_id = 0;
                            dialogConfig.data.login_name = loginName;
                            dialogConfig.data.month = month;
                            dialogConfig.data.year = year;

                            if (params.data.Description !== 'Plane Travel') {
                                dialogConfig.data.distance = params.data.Distance ?? params.data.distance ?? 0;
                                dialogConfig.data.distance_unit = params.data.DistanceUnit ?? params.data.distance_unit ?? 'KM';
                                dialogConfig.data.transportmode_desc = params.data.transportmode_desc ?? '';
                                dialogConfig.data.transport_mode_id = params.data.TransportType ?? params.data.transport_mode_id ?? null;
                            } else {
                                dialogConfig.data.FromAirport = params.data.FromAirport ?? '';
                                dialogConfig.data.ToAirport = params.data.ToAirport ?? '';
                                dialogConfig.data.LayoverAirport1 = params.data.LayoverAirport1 ?? '';
                                dialogConfig.data.LayoverAirport2 = params.data.LayoverAirport2 ?? '';
                                dialogConfig.data.LayoverCount = params.data.LayoverCount ?? 0;
                                // Convert is_roundtrip (0/1) to RoundTrip (boolean)
                                const fallbackRt = params.data?.is_roundtrip ?? (params.data?.RoundTrip === true ? 1 : 0);
                                applyRoundTrip(dialogConfig.data, fallbackRt);
                            }
                        }
                    } else {
                        console.log('No ADLS data returned, initializing as new entry');

                        dialogConfig.data.travel_id = 0;
                        dialogConfig.data.login_name = loginName;
                        dialogConfig.data.month = month;
                        dialogConfig.data.year = year;

                        if (params.data.Description !== 'Plane Travel') {
                            dialogConfig.data.distance = params.data.Distance ?? params.data.distance ?? 0;
                            dialogConfig.data.distance_unit = params.data.DistanceUnit ?? params.data.distance_unit ?? 'KM';
                            dialogConfig.data.transportmode_desc = params.data.transportmode_desc ?? '';
                            dialogConfig.data.transport_mode_id = params.data.TransportType ?? params.data.transport_mode_id ?? null;
                        } else {
                            dialogConfig.data.FromAirport = params.data.FromAirport ?? '';
                            dialogConfig.data.ToAirport = params.data.ToAirport ?? '';
                            dialogConfig.data.LayoverAirport1 = params.data.LayoverAirport1 ?? '';
                            dialogConfig.data.LayoverAirport2 = params.data.LayoverAirport2 ?? '';
                            dialogConfig.data.LayoverCount = params.data.LayoverCount ?? 0;
                            // Convert is_roundtrip (0/1) to RoundTrip (boolean)
                            const fallbackRt = params.data?.is_roundtrip ?? (params.data?.RoundTrip === true ? 1 : 0);
                            applyRoundTrip(dialogConfig.data, fallbackRt);
                        }
                    }

                    prepareAndOpenDialog();
                });
            } // end else (Expense Entry)
        } else {
            //  CREATE (non-dragged): ensure ADLS identity is reset, then open dialog immediately
            dialogConfig.data.travel_id = 0;
            dialogConfig.data.login_name = loginName;
            dialogConfig.data.month = month;
            dialogConfig.data.year = year;

            // carbon_emission is computed on backend create; keep null so backend recalculates cleanly
            dialogConfig.data.carbon_emission = null;

            openDialog();
        }
    }

    // When Cell in AG grid is clicked
    onCellClicked(params): void {
        if (!params.node.group) {
            this.entryService.setEntryTDate(params.data.TDate);
        } else {
            this.entryService.setEntryTDate(params.node.key);
        }
    }

    // Once AG Grid is ready, config
    onGridReady(params): void {
        this._entryGridConfigService
            .getSavedEntryGridConfig(this.entryPageType)
            .subscribe((response) => {
                this.agGridAPI = params.api;
                this.agGridColumnAPI = params.columnApi;
                this.entryService.setGridApi(this.agGridAPI);
                this.entryService.setGridColumnApi(this.agGridColumnAPI);
                this.setEntryGridConfig(response);
                if (!commonFunctions.isNullOrUndefined(response)) {
                    this.agGridColumnAPI.applyColumnState(
                        JSON.parse(response.Configuration)
                    );
                }
                this.agGridCopy = this.agGridAPI;
                this._entryTableService.getEntryTableEntries(
                    this.agGridAPI,
                    this.entryPageType
                );
            });

        this.subscription = this._userService.announceImpersonate$.subscribe(
            (response) => { }
        );
        this.gridOptions.columnApi.getColumn('TDate').setSort('asc');
    }

    //   Move/Copy rows
    onRowDragEnd(params: RowDragEndEvent): void {
        if (
            !(
                params.node.data.Client == 'AD' &&
                (params.node.data.Project == 'TS' || params.node.data.Project == 'EX')
            )
        ) {
            if (this.rowDragModeIsCopy) {
                this.setEntryIsUnsavedChangesPresent(true);
                // const newEntry = {};
                // for (const property in params.node.data) {
                //     newEntry[property] = params.node.data[property];
                // }
                const newEntry: any = structuredClone(params.node.data);
                if (!commonFunctions.isNullOrUndefined(params.overNode)) {
                    if (params.overNode.group) {
                        newEntry['TDate'] = params.overNode.key;
                    } else {
                        newEntry['TDate'] = params.overNode.data.TDate;
                    }
                    if (this.entryPageType == Constants.NAV_TIME_ENTRY_ACTUALS) {
                        if (params.node.data.Charge.toLowerCase() !== 'no') {
                            newEntry['Charge'] = 'yes';
                            newEntry['Invoice_id'] = 0;
                        }
                        newEntry['Time_ID'] = null;
                        newEntry['Invoice_Date'] = newEntry['TDate'];
                    } else {
                        newEntry['Invoice_id'] = 0;
                        newEntry['ExpenseID'] = null;
                        newEntry['Invoice_date'] = newEntry['TDate'];
                    }

                    newEntry.travel_id = 0;
                    newEntry.carbon_emission = null;
                    // Store source ExpenseID for sustainability data lookup during save
                    const isValidSource = params.node.data.ExpenseID && params.node.data.ExpenseID !== 0;
                    newEntry.__sourceExpenseId = isValidSource ? params.node.data.ExpenseID : params.node.data.__sourceExpenseId;
                    newEntry.__sourceDescription = isValidSource ? params.node.data.Description : params.node.data.__sourceDescription;
                    newEntry.__sourceDate = isValidSource ? params.node.data.TDate : params.node.data.__sourceDate;
                    //Sustainability normalization
                    if (this.entryPageType === Constants.NAV_EXPENSE_ENTRY) {
                        const desc = (newEntry.Description ?? '').trim();

                        // RoundTrip boolean <-> is_roundtrip (0/1)
                        if (newEntry.RoundTrip == null) {
                            newEntry.RoundTrip = Number(newEntry.is_roundtrip ?? 0) === 1;
                        }
                        if (newEntry.is_roundtrip == null) {
                            newEntry.is_roundtrip = newEntry.RoundTrip === true ? 1 : 0;
                        } else {
                            // normalize any stray string values ('0'/'1') to number
                            newEntry.is_roundtrip = Number(newEntry.is_roundtrip ?? 0);
                        }

                        if (desc === 'Plane Travel') {
                            // Make sure dialog fields exist (your dialog expects FromAirport/ToAirport)
                            newEntry.FromAirport =
                                newEntry.FromAirport ??
                                newEntry.plane_origin ??
                                newEntry.plane_origin_desc ??
                                null;

                            newEntry.ToAirport =
                                newEntry.ToAirport ??
                                newEntry.plane_destination ??
                                newEntry.plane_destination_desc ??
                                null;

                            newEntry.LayoverAirport1 = newEntry.LayoverAirport1 ?? null;
                            newEntry.LayoverAirport2 = newEntry.LayoverAirport2 ?? null;
                            newEntry.LayoverCount = newEntry.LayoverCount ?? 0;

                            // Keep sustainability mapping consistent
                            newEntry.transport_mode_id = 15;
                            newEntry.transportmode_desc = 'Plane';
                            newEntry.transportModes = 'Plane';
                        } else {
                            // Make sure dialog fields exist (your dialog expects Distance/Unit/TransportType)
                            newEntry.Distance = newEntry.Distance ?? newEntry.distance ?? null;
                            newEntry.DistanceUnit = newEntry.DistanceUnit ?? newEntry.distance_unit ?? null;

                            newEntry.TransportType =
                                newEntry.TransportType ??
                                newEntry.transport_mode_id ??
                                newEntry.transportmode_id ??
                                null;

                            // keep lowercase fields in sync for backend payload later
                            newEntry.distance = newEntry.distance ?? newEntry.Distance;
                            newEntry.distance_unit = newEntry.distance_unit ?? newEntry.DistanceUnit;
                        }
                        //status
                    }
                    if (params.node.data.status !== 'dummy') {
                        newEntry['status'] = 'create';
                        this.setEntryIsUnsavedChangesPresent(true);
                    } else {
                        newEntry['status'] = 'dummy';
                    }

                    newEntry.__createdFromDragCopy = true;
                    this.agGridAPI.applyTransaction({ add: [newEntry] });
                }
            } else {
                if (
                    (this.entryPageType == Constants.NAV_TIME_ENTRY_ACTUALS &&
                        (params.node.data.Charge.toLowerCase() === 'yes' ||
                            params.node.data.Charge.toLowerCase() === 'no')) ||
                    (this.entryPageType == Constants.NAV_EXPENSE_ENTRY &&
                        (params.node.data.Invoice_id === 0 ||
                            params.node.data.ExpenseType === 'Non-Charge'))
                ) {
                    this.setEntryIsUnsavedChangesPresent(true);
                    this.dateEntryCountHashMap.set(
                        params.node.data.TDate.substr(0, 10),
                        this.dateEntryCountHashMap.get(
                            params.node.data.TDate.substr(0, 10)
                        ) - 1
                    );
                    this.setDateEntryCountHashMap(this.dateEntryCountHashMap);
                    if (
                        this.dateEntryCountHashMap.get(
                            params.node.data.TDate.substr(0, 10)
                        ) === 0
                    ) {
                        this._entryTableService.addEmptyRowForEntryDate(
                            params.node.data.TDate.substr(0, 10),
                            this.agGridAPI
                        );
                    }
                    const newRowNodeData = params.node.data;
                    if (!commonFunctions.isNullOrUndefined(params.overNode)) {
                        if (params.overNode.group) {
                            newRowNodeData.TDate = params.overNode.key;
                            if (this.entryPageType == Constants.NAV_TIME_ENTRY_ACTUALS) {
                                newRowNodeData.Invoice_Date = params.overNode.key;
                            } else if (this.entryPageType == Constants.NAV_EXPENSE_ENTRY) {
                                newRowNodeData.Invoice_date = params.overNode.key;
                            }
                        } else {
                            newRowNodeData.TDate = params.overNode.data.TDate;
                            if (this.entryPageType == Constants.NAV_TIME_ENTRY_ACTUALS) {
                                newRowNodeData.Invoice_Date = params.overNode.data.TDate;
                            } else if (this.entryPageType == Constants.NAV_EXPENSE_ENTRY) {
                                newRowNodeData.Invoice_date = params.overNode.data.TDate;
                            }
                        }
                    }
                    newRowNodeData.status = 'update';
                    this.agGridAPI.applyTransaction({ update: [newRowNodeData] });
                }
            }
            if (
                (this.entryPageType == Constants.NAV_TIME_ENTRY_ACTUALS &&
                    (this.rowDragModeIsCopy ||
                        (!this.rowDragModeIsCopy &&
                            (params.node.data.Charge.toLowerCase() === 'yes' ||
                                params.node.data.Charge.toLowerCase() === 'no')))) ||
                (this.entryPageType == Constants.NAV_EXPENSE_ENTRY &&
                    (this.rowDragModeIsCopy ||
                        (!this.rowDragModeIsCopy && params.node.data.Invoice_id === 0)))
            ) {
                if (!commonFunctions.isNullOrUndefined(params.overNode)) {
                    if (params.overNode.group) {
                        if (
                            this.dateEntryCountHashMap.get(
                                params.overNode.key.substr(0, 10)
                            ) === -1
                        ) {
                            const dummyLeafChild = params.overNode.allLeafChildren.filter(
                                (leafChild) => {
                                    return leafChild.data.status === 'dummy';
                                }
                            )[0];
                            this.agGridAPI.applyTransaction({
                                remove: [dummyLeafChild.data],
                            });
                            this.dateEntryCountHashMap.set(
                                params.overNode.key.substr(0, 10),
                                1
                            );
                        } else {
                            this.dateEntryCountHashMap.set(
                                params.overNode.key.substr(0, 10),
                                this.dateEntryCountHashMap.get(
                                    params.overNode.key.substr(0, 10)
                                ) + 1
                            );
                        }
                        this.setDateEntryCountHashMap(this.dateEntryCountHashMap);
                    } else {
                        if (
                            this.dateEntryCountHashMap.get(
                                params.overNode.data.TDate.substr(0, 10)
                            ) === -1
                        ) {
                            const dummyLeafChild =
                                params.overNode.parent.allLeafChildren.filter((leafChild) => {
                                    return leafChild.data.status === 'dummy';
                                })[0];
                            this.agGridAPI.applyTransaction({
                                remove: [dummyLeafChild.data],
                            });
                            this.dateEntryCountHashMap.set(
                                params.overNode.data.TDate.substr(0, 10),
                                1
                            );
                        } else {
                            this.dateEntryCountHashMap.set(
                                params.overNode.data.TDate.substr(0, 10),
                                this.dateEntryCountHashMap.get(
                                    params.overNode.data.TDate.substr(0, 10)
                                ) + 1
                            );
                        }
                        this.setDateEntryCountHashMap(this.dateEntryCountHashMap);
                    }
                    this.entryService.updateActualsAndChangedEntries(this.agGridAPI);
                }
            }
        }
    }

    // Assign values from the clipboard
    processDataFromClipboard = (params) => {
        this.assignValues(params.data);
    };

    // After dragging required row
    onDragStopped(): void {
        let tempEntryGridConfig = { ...this.entryGridConfig };
        if (!commonFunctions.isNullOrUndefined(this.agGridColumnAPI)) {
            if (
                !commonFunctions.isNullOrUndefined(tempEntryGridConfig) &&
                tempEntryGridConfig.id !== 0
            ) {
                tempEntryGridConfig.Configuration = JSON.stringify(
                    this.agGridColumnAPI.getColumnState()
                );
            } else {
                if (this.entryPageType == Constants.NAV_TIME_ENTRY_ACTUALS) {
                    tempEntryGridConfig = new TimeEntryGridConfigModel();
                } else {
                    tempEntryGridConfig = new ExpenseEntryGridConfigModel();
                }
                tempEntryGridConfig.Configuration = JSON.stringify(
                    this.agGridColumnAPI.getColumnState()
                );
            }
            this.entryService.setGridColumnApi(this.agGridColumnAPI);
            this.setEntryGridConfig(tempEntryGridConfig);
        }
    }

    //   On selecting Rows
    onRowSelection(param: any): void {
        const selectedRows = this.agGridAPI.getSelectedRows();
        if (selectedRows.length > 0) {
            this.entryService.entryisRowSelectedForDeletion.next(true);
        } else {
            this.entryService.entryisRowSelectedForDeletion.next(false);
        }
    }
}
